<template>
  <div class="chat-content" style="left: 320px;">
    <div ref="mailContentHeader" class="chat-content-header">
      <!-- <Dropdown @on-click="menuClicked" transfer placement="top-start" trigger="click">
            <a class="link-02 d-none d-lg-block d-xl-none mg-r-20">
              <i class="ivu-icon ivu-icon-md-menu" style="font-size: 18px"></i>
              {{convCur.team}}
            </a>  
            <DropdownMenu slot="list">
              <DropdownItem name="edit"><i class="ivu-icon ivu-icon-md-create m-r-xs"></i>Засах</DropdownItem>              
              <DropdownItem divided name="delete" style="color: orange"><i class="ivu-icon ivu-icon-md-trash m-r-xs"></i>Архивлах</DropdownItem>
            </DropdownMenu>
      </Dropdown>-->

      <div class="d-flex">
        <nav id="channelNav">
          <!-- <a @click="showMention()"><i class="ivu-icon ivu-icon-ios-person-add"></i> Хэрэглэгч нэмэх</a> -->
          <!-- <a class="bd-l" @click="showRightSideBar(1)"><i class="ivu-icon ivu-icon-ios-people"></i>Гишүүд</a>
          <a class="bd-l" @click="showRightSideBar(2)"><i class="ivu-icon ivu-icon-md-filing"></i>Файлууд</a>-->
        </nav>
      </div>
    </div>

    <div class="ps chat-content-body pd-t-20" :style="`height: ${scrHeight}px`">
      <!-- @handle-scroll="handleScroll" -->
      <!-- @handle-scroll-complete="handleComplete" -->
      <vuescroll ref="mainScrll" :ops="scrollOps" @handle-scroll="handleScroll">
        <div class="chat-group">
          <template v-for="(c, i) in convCur.chats">
            <!-- <b-tooltip :target="`tt_${c.id}`" triggers="hover" placement="right" :key="i+'tt'">
                {{c.user.fullName}} {{c.date | moment('YYYY.MM.DD HH:mm, dddd')}}
            </b-tooltip>-->

            <div
              :key="i + 'g'"
              class="chat-group-divider"
              v-show="isDrawGroupDateRange(i)"
            >
              <label
                class="box-list-divider mg-l-0 m-0 text-muted"
                style="font-weight: 400"
                >{{ c.groupDate }}</label
              >
            </div>
            <div class="media mg-x-10 mg-y-10" :key="i" :id="`tt_${c.id}`">
              <div
                v-if="
                  c.user.id != $store.state.user.userInfo.profileId &&
                    !(c.msgType == -1 || (c.msgType >= 5 && c.msgType <= 9))
                "
                class="avatar avatar-sm"
              >
                <img
                  :src="`${c.user.avator}?w=32&h=32&mode=crop`"
                  class="rounded-circle"
                  alt
                />
              </div>
              <div class="media-body">
                <div
                  :title="c.date | moment('YY.MM.DD HH:mm, dddd')"
                  v-if="c.user.id != $store.state.user.userInfo.profileId"
                  class="tx-12 text-muted mg-l-5"
                >
                  {{ c.user.fullName }}
                  <!-- <small
                    class="tx-thin"
                  >{{c.date | moment('YY.MM.DD HH:mm, dddd')}}</small> -->
                </div>
                <div
                  v-if="c.msgType == 0"
                  class="tx-13 d-flex align-items-center"
                >
                  <div
                    v-if="c.user.id != $store.state.user.userInfo.profileId"
                    class="mg-r-5"
                  >
                    <!-- <feather type="message-circle" :size="13" :stroke-width="1"></feather> -->
                  </div>
                  <div v-if="c.user.id != $store.state.user.userInfo.profileId">
                    {{ c.msg }}
                  </div>
                  <div
                    v-else
                    class="bg-primary tx-white mg-l-auto pd-x-20 pd-y-10"
                    style="border-radius: 10px"
                  >
                    {{ c.msg }}
                  </div>
                </div>
                <div
                  v-else-if="c.msgType > 10000 && c.msgType < 10999"
                  class="tx-13 d-flex align-items-center"
                >
                  <div
                    v-if="c.user.id != $store.state.user.userInfo.profileId"
                    class="mg-r-5"
                  >
                    <!-- <feather type="message-circle" :size="13" :stroke-width="1"></feather> -->
                  </div>
                  <div
                    v-if="c.user.id != $store.state.user.userInfo.profileId"
                    class="bg-light pd-x-10 pd-y-5"
                    style="border-radius: 10px"
                  >
                    <div class="text-inherit">
                      <router-link
                        v-if="
                          c.customResponse.rawUrl != '' &&
                            c.customResponse.rawUrl != null
                        "
                        :to="c.customResponse.rawUrl"
                        class="tx-11 link-03"
                      >
                        <feather
                          :type="getMsgIcon(c.msgType)"
                          :size="13"
                          :stroke-width="1"
                          :title="c.customResponse.customTitle"
                          class="pd-r-5"
                        ></feather>
                      </router-link>
                      {{ c.msg }}
                    </div>
                  </div>
                  <div v-else class="mg-l-auto">
                    <div
                      class="bg-primary tx-white pd-x-20 pd-y-10"
                      style="border-radius: 10px"
                    >
                      <template
                        v-if="
                          c.customResponse.rawUrl != '' &&
                            c.customResponse.rawUrl != null
                        "
                      >
                        <router-link
                          :to="c.customResponse.rawUrl"
                          class="text-white"
                        >
                          <feather
                            :type="getMsgIcon(c.msgType)"
                            :size="13"
                            :stroke-width="1"
                            :title="c.customResponse.customTitle"
                            class="pd-r-5"
                          ></feather>
                        </router-link> </template
                      >{{ c.msg }}
                    </div>
                  </div>
                </div>
                <div
                  @click="connect()"
                  v-else-if="c.msgType == -2"
                  class="ivu-alert ivu-alert-warning ivu-alert-with-icon ivu-alert-with-desc"
                  role="button"
                >
                  <span class="ivu-alert-icon">
                    <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
                  </span>
                  <span class="ivu-alert-message">Сүлжээний холболт</span>
                  <span class="ivu-alert-desc">
                    Сүлжээний холболт салсан байна.
                    <a>ЭНД дарж дахин холбогдоно уу.</a>
                  </span>
                </div>
                <div v-else-if="c.msgType == 1" class="d-flex">
                  <div
                    v-if="c.user.id != $store.state.user.userInfo.profileId"
                    class="bg-light mg-l-5 d-flex align-items-center tx-12 pd-5"
                    @click="openLink(c.attach)"
                    role="button"
                    style="border-radius: 10px"
                  >
                    <img
                      class="rounded mg-r-5"
                      v-if="
                        c.attach.ext == 'jpg' ||
                          c.attach.ext == 'jpeg' ||
                          c.attach.ext == 'png'
                      "
                      :src="`${c.attach.link}?w=42&h=42&mode=crop`"
                    />
                    <!-- <img    v-else :src="getthumb(c.attach.ext)" /> -->
                    <div>
                      {{ c.attach.name }}
                      <div class="text-right text-muted">
                        {{ getSize(c.attach.size) }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    class="mg-l-auto bg-primary tx-white pd-x-5 pd-y-5 d-flex align-items-center tx-12"
                    style="border-radius: 10px;"
                    @click="openLink(c.attach)"
                    role="button"
                  >
                    <img
                      class="rounded mg-r-5"
                      v-if="
                        c.attach.ext == 'jpg' ||
                          c.attach.ext == 'jpeg' ||
                          c.attach.ext == 'png'
                      "
                      :src="`${c.attach.link}?w=42&h=42&mode=crop`"
                    />
                    <div>
                      {{ c.attach.name }}
                      <div class="text-right">{{ getSize(c.attach.size) }}</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="c.msgType == 3">
                  <a :href="c.msg" target="_blank" class="tx-brand-01">{{
                    c.msg
                  }}</a>
                </div>
                <div
                  v-else-if="c.msgType == 5 || c.msgType == 6"
                  :class="
                    `tx-12 pd-y-1 pd-x-5 text-lowercase text-muted ${
                      $store.state.app.skin.dark ? '' : '  '
                    }  rounded tx-thin`
                  "
                  role="alert"
                >
                  <i
                    :class="
                      `icon ion-md-${
                        c.msgType == 6 ? 'remove' : 'add'
                      } mg-r-5 tx-12`
                    "
                  ></i>
                  <span class="tx-12"
                    >{{ c.task.lat }}&nbsp;{{ c.task.task }}</span
                  >
                  <i></i> хэрэглэгчийг
                  <i>{{ c.msgType == 6 ? "хаслаа" : "нэмлээ" }}.</i>
                </div>
                <div v-else-if="c.msgType == -1">
                  <i
                    :class="`ivu-icon ivu-icon-ios-people user-add m-r-sm`"
                    style="font-size: 24px;"
                  ></i>
                  бүлгийг
                  <b>үүсгэв.</b>
                </div>
                <div v-else-if="c.msgType == 7">
                  <i
                    :class="`ivu-icon ivu-icon-ios-undo restore-team m-r-sm`"
                    style="font-size: 24px;"
                  ></i>
                  бүлгийг
                  <b>сэргээв.</b>
                </div>
                <div v-else-if="c.msgType == 8">
                  <i
                    :class="`ivu-icon ivu-icon-ios-archive archive-team m-r-sm`"
                    style="font-size: 24px;"
                  ></i>
                  бүлгийг
                  <b>архивласан.</b>
                </div>
                <div v-else-if="c.msgType == 9">
                  <i
                    :class="`ivu-icon ivu-icon-ios-cog update-team m-r-sm`"
                    style="font-size: 24px;"
                  ></i>
                  бүлгийн
                  <b>нэр сольсон.</b>
                </div>
              </div>
            </div>
          </template>
        </div>
      </vuescroll>
    </div>
    <!-- <div class="chat-sidebar-right ps">
      <div class="pd-y-10 pd-x-5">
        <div class="chat-member-list">
          <vue-custom-scrollbar :style="`max-height:calc(100vh - 200px)`">
            <template v-for="(m,i) in convCur.members">
              <div
                v-show="isDrawGroup(i)"
                class="tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10"
                :key="i+'g'"
              >{{m.groupName}}</div>
              <a href="javascript:void(0)" class="media" :key="i" :class="{'bg-admin': m.isOwner}">
                <div class="avatar avatar-sm avatar-online">
                  <img    :src="m.avator" class="rounded-circle" alt />
                </div>
                <div class="media-body mg-l-10">
                  <h6 class="mg-b-0">{{m.fullName}} {{m.isOwner?' | Админ':''}}</h6>
                  <p>{{m.position}}</p>
                </div>
              </a>
            </template>
          </vue-custom-scrollbar>
        </div>
        <div class="chat-member-list">
          <vue-custom-scrollbar :style="`max-height:calc(100vh - 200px)`">
            <a
              @click="openLink(f)"
              href="javascript:void(0)"
              class="media bd-b"
              v-for="(f,i) in convCur.files"
              :key="i"
            >
              <div class="avatar avatar-sm avatar-online">
                <img   
                  v-if="f.ext=='jpg' || f.ext=='jpeg' || f.ext=='png'"
                  :src="f.link+'?w=36&h=32&mode=pad'"
                  style="width:36px"
                />
                <img    v-else :src="getthumb(f.ext)" />
              </div>
              <div class="media-body mg-l-10">
                <h6 class="mg-b-0">{{f.attachment}}</h6>
                <div
                  class="text-muted"
                >{{f.size>1024 ? ((f.size/1024)/1024).toFixed(2)+'MB' : (f.size/1024).toFixed(2)+'KB'}}</div>
              </div>
            </a>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>-->
    <!-- <div v-if="composeObj.chooserShow" class="chat-content-footer-top">
      <div @click="fileUploaderVisible = true">
        <a>
          <feather type="cloud" ></feather> Миний файлуудаас сонгох
        </a>
      </div>
    </div>-->
    <media-finder
      v-if="mediaFinder.show"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = false"
    ></media-finder>
    <div v-if="composeObj.chooserShow" class="chat-content-footer-top wd-30p">
      <simple-uploader
        v-model="composeObj.attachId"
        :propBoxId="0"
        :propObjectId="'0'"
        :propObjectTypeId="6"
        @on-success="fileUploaded($event)"
      >
        <div slot="trigger">
          <div v-if="composeObj.attachId == null" class="btn-group wd-100p">
            <div class="btn btn-outline-success">
              <feather type="upload" class="mg-r-5"></feather>
              <span>Компьютероос файл хуулах</span>
            </div>
          </div>
          <div v-else class="btn-group wd-100p">
            <div
              class="btn btn-outline-success"
              @click.stop="$emit('on-attach', composeObj.attachId)"
            >
              <feather type="eye"></feather>Файл харах
            </div>
            <div
              class="btn btn-danger"
              @click.prevent.stop="composeObj.attachId = null"
            >
              <feather type="x"></feather>Салгах
            </div>
          </div>
        </div>
      </simple-uploader>
    </div>
    <div
      ref="chatComposeArea"
      class="chat-content-footer d-flex justify-content-center align-items-center bd-t ht-55"
    >
      <a
        @click="openCompose()"
        class="chat-plus wd-10p text-center"
        role="button"
      >
        <feather v-if="!composeObj.chooserShow" type="plus"></feather>
        <feather v-if="composeObj.chooserShow" type="x"></feather>
      </a>
      <a
        @click="filterByRawUrl()"
        class="chat-plus wd-10p text-center"
        role="button"
      >
        <feather v-if="!rawUrlFiltered" type="filter"></feather>
        <feather v-if="rawUrlFiltered" type="x"></feather>
      </a>
      <form @submit.prevent="sendMessage()" class="wd-70p">
        <input
          v-model="composeObj.txt"
          type="text"
          class="el-input__inner mg-l-5"
          placeholder="Мессеж"
        />
      </form>
      <nav class="wd-10p text-center">
        <a @click="sendMessage()" role="button">
          <feather type="send"></feather>
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import { request } from "@/api/all";
import { Notification } from "element-ui";
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getSize } from "@/libs/tools";

var _ = require("lodash");
const moment = require("moment");
export default {
  components: {
    vuescroll,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    teamId: {
      type: Number,
      default: () => 0
    },
    obj: {
      type: Object,
      default: () => null
    },
    fullheight: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      scrHeight: 150,
      chatHeight: 400,
      scrollOps: {
        //maxHeight: 300,
        vuescroll: {
          //maxHeight: 300,
        },
        scrollPanel: {
          //maxHeight: 300
        },
        rail: {},
        bar: {}
      },
      convCur: {
        id: 0,
        team: "",
        chats: [],
        members: [],
        files: [],
        isScrollHandled: true,
        curPage: 0,
        pageSize: 20
      },
      composeObj: {
        txt: "",
        type: 0,
        chooserShow: false,
        attachIds: [],
        attachList: []
      },
      chatAttachOption: {
        type: 0,
        title: "",
        rawUrl: ""
      },
      fileUploaderVisible: false,
      mediaFinder: {
        show: false,
        obj: 0,
        key: 0
      },
      rawUrlFiltered: false
    };
  },
  mounted() {
    if (this.teamId > 0) {
      this.setChatAttachOption();
      let self = this;
      this.load(this.teamId, "", true);
      this.$store.state.signalr.osrCon.on(
        "v2recieveTeamMessage",
        (
          date,
          teamId,
          msg,
          type,
          objectId,
          profileId,
          fullName,
          avator,
          attach,
          cstmResp
        ) => {
          if (this.convCur.id == teamId) {
            this.convCur.chats.push({
              msg: msg,
              date: date,
              msgType: type,
              groupDate: self.getDateGroupName(date),
              user: {
                id: profileId,
                avator: avator,
                fullName: fullName
              },
              attach: {
                id: attach.id,
                groupId: attach.groupId,
                name: attach.name,
                link: attach.link,
                ext: attach.ext,
                size: attach.size
              },
              customResponse: cstmResp
            });

            request({
              api: { url: "team/SetLastSeenDate", method: "post" },
              data: { id: teamId }
            }).then(() => {
              if (this.$refs["mainScrll"] != undefined) {
                this.$refs["mainScrll"].scrollTo(
                  {
                    y: "150%"
                  },
                  300
                );
              }
            });
          } else {
            this.handleTeamNotSeenCount(
              this.$store.state.signalr.notSeenCount + 1
            );
          }
          // else {
          //   let _cc = this.conversations.filter(x => x.id == teamId);
          //   if (_cc.length) {
          //     _cc[0].count++;
          //   } else {
          //     getTeamConversations({ id: teamId, skip: 0, size: 1 }).then(res => {
          //       if (res != false && res.data.conversations.length) {
          //         let _cc = res.data.conversations[0];
          //         _cc.count++;
          //         this.conversations.unshift(_cc);
          //       }
          //     });
          //   }
          // }
        }
      );
    }
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    getWindowHeight() {
      this.scrHeight =
        window.innerHeight -
        (this.fullheight || this.$store.state.app.isMobile ? 107 : 170);
    },
    getSize(size) {
      return getSize(size);
    },
    getMsgIcon(type) {
      switch (type - 10000) {
        case 115:
          return "briefcase";
        case 6:
          return "paperclip";
        case 114:
          return "file";
        default:
          return "clipboard";
      }
    },
    filterByRawUrl() {
      this.rawUrlFiltered = !this.rawUrlFiltered;
      this.load(this.convCur.id, this.convCur.team, true);
    },
    fileUploaded(e) {
      this.composeObj.attachTitle = e.uploadedName;
      this.composeObj.txt = e.uploadedName;
      this.composeObj.attachId = e.uploadedAttachmentId;
      this.composeObj.type = 1;
      this.sendMessage();
      //this.composeObj.txt= 'Файл: ' + e.name;
    },
    fileAttached(e) {
      this.composeObj.attachTitle = e.t;
      this.composeObj.attachId = e.id;
      this.composeObj.txt = e.t;
      this.mediaFinder.show = false;
      this.composeObj.type = 1;
      this.sendMessage();
      //this.composeObj.txt= 'Файл: ' + e.name;
    },
    ...mapActions(["handleTeamNotSeenCount"]),
    connect: function() {
      let self = this;
      this.$store.state.signalr.osrCon
        .start()
        .then(function() {
          Notification.success({
            message: "Амжилттай холбогдлоо.",
            duration: 5000
          });
          let ind = self.convCur.chats.map(x => x.type).indexOf(-2);
          self.convCur.chats.splice(ind, 1);
        })
        .catch(() => {
          Notification.info({
            message: "Интернет холболтоо шалгана уу.",
            //title: "Мэдэгдэл",
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        });
    },
    setChatAttachOption() {
      if (this.obj != null) {
        this.chatAttachOption.title = this.obj.title;
        this.chatAttachOption.rawUrl = this.$route.path;
        if (this.$route.name == "lmsCourseView") {
          this.chatAttachOption.type = 10115;
        } else if (this.$route.name == "lmsLessonView") {
          if (this.$route.params.bot == 6 || this.$route.params.bot == 286)
            this.chatAttachOption.type = 10006;
          else if (this.$route.params.bot == 0)
            this.chatAttachOption.type = 10114;
          else this.chatAttachOption.type = this.$route.params.bot + 10000;
        }
      }
    },
    // handleComplete(e) {
    //
    // },
    //handleScroll(vertical, horizontal, nativeEvent) {
    handleScroll(vertical) {
      if (vertical.scrollTop < 20 && !this.convCur.isScrollHandled) {
        this.convCur.curPage = this.convCur.curPage + 1;
        if (
          this.convCur.chats.length < this.convCur.chatsCount &&
          !this.convCur.isScrollHandled
        ) {
          this.convCur.isScrollHandled = true;
          this.load(this.convCur.id, this.convCur.team, false);
        }
      }
    },
    openCompose() {
      this.composeObj.chooserShow = !this.composeObj.chooserShow;
    },
    sendMessage() {
      let self = this;
      if (
        self.$store.state.signalr.osrCon != undefined &&
        self.$store.state.signalr.osrCon.connection != undefined &&
        self.$store.state.signalr.osrCon.connection.connectionState == 1
      ) {
        let embedMsgType = this.composeObj.type;
        if (
          this.composeObj.type == 0 &&
          this.chatAttachOption.type > 10000 &&
          this.chatAttachOption.type < 10999
        ) {
          embedMsgType = this.chatAttachOption.type;
        }
        this.$store.state.signalr.osrCon
          .invoke(
            "v2sendTeamMessage",
            this.$store.state.user.userInfo.profileId,
            this.convCur.id,
            this.composeObj.txt,
            embedMsgType,
            this.composeObj.type == 1 ? this.composeObj.attachId : null,
            this.chatAttachOption.rawUrl,
            this.chatAttachOption.title
          )
          .catch(() => {
            this.convCur.chats.push({
              msg: "Сүлжээний холболт салсан байна",
              msgType: -2,
              date: Date(),
              groupDate: self.getDateGroupName(Date()),
              user: {
                id: this.$store.state.user.userInfo.profileId,
                avator: this.$store.state.user.userInfo.avator,
                fullName: this.$store.state.user.userInfo.fullName
              }
            });
            //this.$Notice.warning({ title: "Сүлжээний холболт салсан байна", desc: 'Дахин ачааллана уу' });
          })
          .then(() => {
            this.composeObj.chooserShow = false;
            this.composeObj.txt = "";
            this.composeObj.attachId = null;
          });
      } else {
        this.convCur.chats.push({
          msg: "Сүлжээний холболт салсан байна",
          msgType: -2,
          date: Date(),
          groupDate: self.getDateGroupName(Date()),
          user: {
            id: this.$store.state.user.userInfo.profileId,
            avator: this.$store.state.user.userInfo.avator,
            fullName: this.$store.state.user.userInfo.fullName
          }
        });
      }
    },
    openLink(e) {
      this.$emit("on-attach", e.id);
    },
    isDrawGroup(i) {
      if (i == 0) {
        return true;
      } else if (
        this.convCur.members[i]["groupName"] !=
        this.convCur.members[i - 1]["groupName"]
      ) {
        return true;
      } else {
        return false;
      }
    },
    getDateGroupName(d) {
      let rv = "";

      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    isDrawGroupDateRange(i) {
      if (i == 0) {
        return true;
      } else if (
        this.convCur.chats[i]["groupDate"] !=
        this.convCur.chats[i - 1]["groupDate"]
      ) {
        return true;
      } else {
        return false;
      }
    },
    setScrollHeight() {
      //var minusHeight= 40 + 55 + 60;
      //var minusHeight= 95 + this.$refs.chatComposeArea.$el.offsetHeight;
      //$(this.$el).find(".ivu-scroll-container").css({ height: window.innerHeight - minusHeight});
      // this.$nextTick(function() {
      //   $(this.$el).find('ivu-scroll-content').css("display",  'contents');
      // });
    },
    load(id, team, force) {
      let self = this;

      if (force) {
        this.convCur.chats = [];
        this.composeObj.chooserShow = false;
        //this.handleTeamId(0);
      }

      let urlFiltered = this.rawUrlFiltered == true ? this.$route.path : "";
      request({
        api: { method: "get", url: "team/GetChatLog" },
        store: self.$store,
        params: {
          skip: this.convCur.chats.length,
          size: this.convCur.pageSize,
          teamId: id,
          rawUrl: urlFiltered
        }
      }).then(res => {
        if (res != false) {
          request({
            api: { url: "team/SetLastSeenDate", method: "post" },
            data: { id: id }
          }).then(res => {
            if (res != false) {
              // if (this.conversations.filter(x => x.id == id).length)
              //   this.conversations.filter(x => x.id == id)[0].count = 0;
              // notSeenConversationCount().then(res => {
              //   if (res != false) this.handleTeamUnseenCount(res.data.count);
              // });
            }
          });

          this.convCur.chatsCount = res.data.count;
          //this.convCur.chats= this.convCur.chats.concat(_.orderBy(res.data.chats.map(e => Object.assign(e, { groupDate: self.getDateGroupName(e.date), })), ["id"], ["asc"] ));
          //# TODO: busgsnuus chihnee 1 1 eer ni guigeed chatbox s harna
          _.orderBy(res.data.chats, ["id"], ["desc"]).forEach(value => {
            Object.assign(value, {
              groupDate: self.getDateGroupName(value.date)
            });
            self.convCur.chats.unshift(value);
          });

          this.convCur.team = team;
          this.convCur.id = id;
          let goPos = 0;
          if (this.$refs["mainScrll"] != undefined)
            goPos = this.$refs["mainScrll"].scrollContentElm.offsetHeight;

          this.$nextTick(function() {
            if (this.$refs["mainScrll"] != undefined) {
              if (!force) {
                let afterPos = this.$refs["mainScrll"].scrollContentElm
                  .offsetHeight;
                this.$refs["mainScrll"].scrollTo(
                  {
                    y: afterPos - goPos
                  },
                  0
                );
              } else {
                this.$refs["mainScrll"].scrollTo(
                  {
                    y: "150%"
                  },
                  0
                );
              }
            }
            this.convCur.isScrollHandled = false;
          });
        }
      });
    }
  }
};
</script>

<style>
.chat-content-footer-top {
  background-color: #fff;
  position: absolute;
  bottom: 51px;

  right: -1;
  border-top: 1px solid rgba(72, 94, 144, 0.16);
  height: 100px;
  display: flex;

  align-items: center;
  justify-content: center;
}
</style>
